module.exports = __webpack_public_path__ + "img/Kinesis-LDNS-White.19f0f4f7.webp";